'use strict';

exports.__esModule = true;
exports.AlertContent = exports.AlertIcon = exports.AlertBase = exports.ALERT_TONES = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  width: ', ';\n  padding: 0.75rem 1.25rem;\n  margin: 1rem auto;\n  border: 1px solid ', ';\n  display: flex;\n  align-items: center;\n'], ['\n  width: ', ';\n  padding: 0.75rem 1.25rem;\n  margin: 1rem auto;\n  border: 1px solid ', ';\n  display: flex;\n  align-items: center;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 40px;\n  margin-right: ', ';\n'], ['\n  color: ', ';\n  font-size: 40px;\n  margin-right: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  flex: 1;\n  color: ', ';\n  font-weight: ', ';\n'], ['\n  flex: 1;\n  color: ', ';\n  font-weight: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _spacing = require('../../../styles/spacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// Primitiv-Bibliothek (2026-06): zentrales Tone-Banner-Primitiv (Alert).
// Faehrt die 3 byte-fast-identischen Banner Error/Info/Success auf EINE Basis
// zurueck. Kapselt die gemeinsame Box (flex, padding 0.75rem 1.25rem,
// margin 1rem auto, 1px-Border) + die Tone-spezifische Farbe (Border/Icon/Content).
// Token-Aufloesung mit Fallback-Kette analog Card/Button (greift nur ohne
// vollstaendigen ThemeProvider). Layout (z.B. width) bleibt Tone-/Konsumenten-Sache.

var ALERT_TONES = exports.ALERT_TONES = { ERROR: 'error', INFO: 'info', SUCCESS: 'success' };

// Tone-Farbe = Border + Icon + (meist) Content-Text. error rot, info amber,
// success gruen. WICHTIG (Bugfix 2026-06): success benutzt approveColor (#2e9e5b),
// NICHT mehr theme.green (#7ac943, grelles Gift-Gruen) — analog ButtonStyled.APPROVE.
var resolveToneColor = function resolveToneColor(_ref) {
  var theme = _ref.theme,
      tone = _ref.tone;

  switch (tone) {
    case ALERT_TONES.INFO:
      return theme.warningColor || '#ffa834';
    case ALERT_TONES.SUCCESS:
      return theme.approveColor || '#2e9e5b';
    case ALERT_TONES.ERROR:
    default:
      return theme.errorColor || '#d92b3c';
  }
};

// Content-Farbe: error/success tragen die Tone-Farbe auf dem Text; info NICHT
// (Info-Text bleibt im normalen Text-Schwarz, nur fett) — verhaltens-erhaltend
// gegenueber dem alten InfoContent (dort war der color-Reset auskommentiert).
var resolveContentColor = function resolveContentColor(_ref2) {
  var theme = _ref2.theme,
      tone = _ref2.tone;

  if (tone === ALERT_TONES.INFO) {
    return 'inherit';
  }
  return resolveToneColor({ theme: theme, tone: tone });
};

// Content-Gewicht: info ist fett (fontWeightBold). error/success ERBEN das Gewicht
// vom Kontext (inherit) — 1:1 wie die Alt-Banner, die GAR KEINE font-weight trugen.
// WICHTIG: NICHT 'normal' (=400) setzen — der Body erbt fontWeightMedium (300,
// Montserrat-Medium); 400 ist im Theme an die Montserrat-BOLD-Datei gebunden, also
// waere 'normal' ein sichtbarer Bold-Shift. 'inherit' haelt den geerbten 300er-Wert.
var resolveContentWeight = function resolveContentWeight(_ref3) {
  var theme = _ref3.theme,
      tone = _ref3.tone;
  return tone === ALERT_TONES.INFO ? theme.fontWeightBold || 400 : 'inherit';
};

// width: Info/Success trugen width:100%, Error NICHT. Per Default ueber fullWidth
// gesteuert (Wrapper setzen ihren Tone-Default). Error -> kein width (auto).
var resolveWidth = function resolveWidth(_ref4) {
  var fullWidth = _ref4.fullWidth;
  return fullWidth ? '100%' : 'auto';
};

var AlertBase = exports.AlertBase = _styledComponents2.default.div(_templateObject, resolveWidth, resolveToneColor);

var AlertIcon = exports.AlertIcon = (0, _styledComponents2.default)(_reactFontawesome.FontAwesomeIcon)(_templateObject2, resolveToneColor, (0, _spacing.space)(25));

var AlertContent = exports.AlertContent = _styledComponents2.default.div(_templateObject3, resolveContentColor, resolveContentWeight);